import React, { useEffect, useMemo, useRef, useState } from 'react';
import AppNavbar from '../Navbar/AppNavbar';
import Footer from '../Navbar/Footer';
import "../../assets/css/activity_page.scss"
import { useDispatch, useSelector } from 'react-redux';
import { Box, Skeleton } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import { Circles } from 'react-loader-spinner';
import { useLocation } from 'react-router-dom';
import FilterBar from '../CommonFile/FilterBar';
import PageBreadcome from '../CommonFile/PageBreadcome';
import DataGridTable from '../CommonFile/DataGridTable';
import { getActivityIcon } from '../CommonFile/Function_utils';
import moment from 'moment';
import { loadRecentActivities } from '../redux/activityService/act_action';
import { activity_type } from '../CommonFile/DropdownValues';

function ActivityLogs() {

    const dispatch = useDispatch();
    const location = useLocation();

    const { totalPages } = useSelector(state => state.sbndata);
    const { recent_activity_data } = useSelector(state => state.activitydata);
    const { totalDataCount } = useSelector(state => state.data);
    const [tableHeight, setTableHeight] = useState(0);

    const [loadData, setLoadData] = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)
    const [filterValues, setFilterValues] = useState({
        page: 1,
        page_size: 10,
        activity_type: "",
        search_text: "",
        from_date: null,
        to_date: null,
    })

    const divRef = useRef(null);
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);

    // region set table height
    useEffect(() => {
        if (div1Ref.current) {
            setHeight1(div1Ref.current.offsetHeight);
        }
        if (div2Ref.current) {
            setHeight2(div2Ref.current.offsetHeight);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!divRef.current) return;

        const parentHeight = divRef.current.offsetHeight;

        const pixelAdjustment = height1 + height2 + 65;

        const tablePxHeight = parentHeight - pixelAdjustment;

        setTableHeight(tablePxHeight);
    }, [height1, height2]);
    // endregion

    useEffect(() => {
        console.log(location, "location")
        if (location.state) {
            if (location.state?.sbn_type) {
                setFilterValues((prev) => ({
                    ...prev,
                    sbn_type: location.state?.sbn_type
                }));
            }
        }
    }, [location])

    useEffect(() => {
        const today = new Date();

        // First day of the current month
        const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
        );

        setFilterValues((prev) => ({
            ...prev,
            from_date: firstDayOfMonth,
            to_date: today,
        }));

        const filters = {
            ...filterValues,
            from_date: firstDayOfMonth,
            to_date: today,
        }

        setLoadData(true)
        pageLoadFunction(filters)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pageLoadFunction = (filterValues) => {
        const params = {
            page: filterValues.page,
            page_size: filterValues.page_size,
            activity_type: filterValues.activity_type,
            search_text: filterValues.search_text,
            start_date: moment(filterValues.from_date).format("YYYY-MM-DD"),
            end_date: moment(filterValues.to_date).format("YYYY-MM-DD"),
        }

        dispatch(loadRecentActivities(params)).then(
            (resp) => {
                setLoadData(false)
                setLoadingMore(false)
            }
        )
            .catch((err) => {
                setLoadingMore(false)
                setLoadData(false)
            });
    }


    const searchFunction = (filterValues) => {
        const filter = {
            ...filterValues,
            page: 1
        }
        setLoadingMore(true)
        setFilterValues(filter)
        pageLoadFunction(filter)
    }
    // , [filterValues])

    // #region fucntion for clear filters
    const clearFunction = () => {
        const today = new Date();

        const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
        );

        const filter = {
            page: 1,
            page_size: 10,
            activity_type: "",
            search_text: "",
            from_date: firstDayOfMonth,
            to_date: today,
        }
        setLoadingMore(true)
        setFilterValues(filter)
        pageLoadFunction(filter);
    }
    // #endregion

    // region Define DataGrid columns
    const columns = useMemo(() => {
        const baseColumns = [
            {
                field: "activity_type",
                headerName: "",
                minWidth: 60,
                maxWidth: 60,
                headerAlign: "center",
                renderCell: (params) => {
                    if (params.row.isSkeleton) {
                        return <div className="activity-icon-sec">
                            <div className="activity-item">
                                <div className={`activity-icon`}>
                                    <Skeleton variant="circular" width={28} height={28} />
                                </div>
                            </div>
                        </div>
                    }

                    const activity = getActivityIcon(params.row.activity_type);

                    return (
                        <div className="activity-icon-sec">
                            <div className="activity-item">
                                <div className={`activity-icon ${activity.className}`}>
                                    {activity.icon}
                                </div>
                            </div>
                        </div>
                    );
                },
            },
            {
                field: "user_name",
                headerName: "User Name",
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="80%" />
                    ) : (
                        params.value
                    ),
            },
            {
                field: "user_email",
                headerName: "Email",
                flex: 2,
                minWidth: 250,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="90%" />
                    ) : (
                        <div className="activity-icon-sec">
                            <div className="activity-title">
                                <div>
                                    <span className="activity-email-bg">{params.value}</span>
                                </div>
                            </div>
                        </div>
                    ),
            },
            {
                field: "activity_title",
                headerName: "Title",
                flex: 2,
                minWidth: 200,
                renderCell: (params) => {
                    if (params.row.isSkeleton) {
                        return <Skeleton variant="text" width="75%" />;
                    }

                    const activity = getActivityIcon(params.row.activity_type);

                    return (
                        <div className="activity-icon-sec">
                            <div className="activity-title">
                                <div>
                                    <span className={`activity-text-bg ${activity.className}`}>
                                        {params.value}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                },
            },
            {
                field: "activity_description",
                headerName: "Description",
                flex: 3,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="95%" />
                    ) : (
                        params.value
                    ),
            },
            {
                field: "time_ago",
                headerName: "TAT",
                flex: 1,
                minWidth: 120,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="60%" />
                    ) : (
                        params.value
                    ),
            },
            {
                field: "created_date",
                headerName: "Date",
                flex: 2,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="85%" />
                    ) : (
                        <b>{moment(params.value).format("DD MMM, YYYY - hh:mm A")}</b>
                    ),
            },
        ];

        return baseColumns;
    }, []);

    // #region handle scroll
    useEffect(() => {
        const container = document.querySelector('.MuiDataGrid-virtualScroller');
        if (!container) return;

        let lastScrollTop = 0;

        const handleScroll = () => {
            if (!container || loadingMore) return;

            const currentScrollTop = container.scrollTop;

            if (currentScrollTop <= lastScrollTop) return;

            lastScrollTop = currentScrollTop;

            const distanceFromBottom = container.scrollHeight - currentScrollTop - container.clientHeight;

            if (distanceFromBottom === 0 && recent_activity_data.length < totalDataCount && !loadingMore) {
                setLoadingMore(true);
                setFilterValues((prev) => {
                    if (prev.page >= totalPages) return prev;

                    return {
                        ...prev,
                        page: prev.page + 1,
                    };
                });
                const filter = {
                    ...filterValues,
                    page: filterValues.page + 1
                }
                pageLoadFunction(filter);
            }
        };

        container.addEventListener('scroll', handleScroll);

        // Cleanup function
        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingMore, recent_activity_data, totalDataCount, setFilterValues]);
    // #endregion


    const handleFilterValues = (e) => {
        const { name, value } = e.target;

        setFilterValues((prev) => ({
            ...prev,
            [name]: value,
            page: 1,
        }));
    }

    const handleDateChange = (name, date) => {
        setFilterValues((prev) => {
            const updated = {
                ...prev,
                [name]: date,
                page: 1,
            };

            // If From Date is cleared, clear To Date as well
            if (name === "from_date" && !date) {
                updated.to_date = null;
            }

            // If From Date changes and To Date is before it, clear To Date
            if (
                name === "from_date" &&
                date &&
                updated.to_date &&
                updated.to_date < date
            ) {
                updated.to_date = null;
            }

            return updated;
        });
    };

    // console.log(filterValues, "filterValues")

    const dataRows = loadData
        ? Array.from({ length: 12 }, (_, index) => ({
            id: `skeleton-${index}`, // unique key
            isSkeleton: true,
        }))
        : recent_activity_data.map((row, index) => ({
            ...row,
            id: row.id ?? row.activity_id ?? `row-${index}`, // unique key for real rows
        }));

    return (
        <div className="page-layout" style={{ position: "relative" }}>
            <AppNavbar />
            <div className="page-content" style={{ overflow: "auto" }}>
                <div className='subcription-main-page'>
                    <div className="subscription-page" ref={divRef}>

                        <div ref={div1Ref}>
                            <PageBreadcome heading="User Activity"
                                sub_heading="Monitor and manage user activities across the application." />
                        </div>

                        <div ref={div2Ref}>
                            <FilterBar filterValues={filterValues}
                                handleFilterValues={handleFilterValues}
                                handleDateChange={handleDateChange} displayPage="Activity"
                                searchFunction={() => searchFunction(filterValues)} clearFunction={clearFunction}
                                select_type="activity_type" select_values={activity_type} />
                        </div>

                        <div className="subscription-content">
                            {/* <RecentActivityCard displayData={recent_activity_data} /> */}
                            {/* Table comes here */}
                            <Box sx={{ width: '100%', mt: 2 }}>
                                <DataGridTable rowData={dataRows}
                                    columns={columns} height={`${tableHeight}px !important`}
                                    page="activity"
                                />
                                {(loadingMore) && <div className='loader-css'>
                                    <div className="d-flex justify-content-center align-items-center py-4">
                                        <Circles
                                            height="30"
                                            width="30"
                                            color="#007bff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        />
                                    </div>
                                </div>}
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ActivityLogs
